import React from 'react';

const SoundlyInvestContext = React.createContext({
    reportid: 0,
    propAddress: '',
    purchasePrice: '',
    downPayment: '',
    interestRate: '',
    loanPeriod: '',
    rentalIncome: '',
    storageIncome: '',
    parkingIncome: '',
    taxRate: '',
    propertyManager: '',
    insurance: '',
    utilities: '',
    gardener: '',
    miscellaneous: '',
    vacancyRate: '',
    pagePurchase: false,
    pageIncome: false,
    pageExpenses: false,
    pageReport: false,
    reports: [],
    setReportId: () => {},
    setAddress: () => {},
    setPrice: () => {},
    setDownPayment: () => {},
    setInterestRate: () => {},
    setLoanPeriod: () => {},
    setRentalIncome: () => {},
    setStorageIncome: () => {},
    setParkingIncome: () => {},
    setTaxRate: () => {},
    setPropertyManager: () => {},
    setInsurance: () => {},
    setUtilities: () => {},
    setGardener: () => {},
    setMiscellaneous: () => {},
    setVacancyRate: () => {},
    setPagePurchase: () => {},
    setPageIncome: () => {},
    setPageExpenses: () => {},
    setPageReport: () => {},
    addReport: () => {},
    deleteReport: () => {},
    updateReport: () => {},
    setUserId: () => {},
    setUserName: () => {},
});

export default SoundlyInvestContext;